import { render, staticRenderFns } from "./booking-history.vue?vue&type=template&id=6e51851c&scoped=true"
import script from "./booking-history.vue?vue&type=script&lang=js"
export * from "./booking-history.vue?vue&type=script&lang=js"
import style0 from "./booking-history.vue?vue&type=style&index=0&id=6e51851c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e51851c",
  null
  
)

export default component.exports